module.exports = "/_next/static/images/0f4cb546ac0667c573da6ccf6bdbc3ae-hero-lg.png";